// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   loginStart,
//   loginSuccess,
//   loginFailure,
//   setFirstLogin,
// } from '../../store/slices/authSlice';
// import authApi from 'api/authApi';
// import { Shield, Mail, Lock, Eye, EyeOff, Loader2 } from 'lucide-react';
// import { Button } from '../../components/ui/button';
// import { Input } from '../../components/ui/input';
// import { Label } from '../../components/ui/label';
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
// } from '../../components/ui/card';
// import { toast } from 'sonner';
// import { cn } from '../../lib/utils';
// import Logo from 'src/assets/images/logo.png';

// const LoginPage = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const { isAuthenticated, isLoading, isFirstLogin } = useSelector((state) => state.auth);

//   const [formData, setFormData] = useState({ emailOrCode: '', password: '' });
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);

//   /* --------------------------------------------------------------- */
//   /* 1. Redirect if already logged in                                 */
//   /* --------------------------------------------------------------- */
//   // useEffect(() => {
//   //   if (isAuthenticated) {
//   //     if (isFirstLogin) {
//   //       toast.success('First login – please set up security.');
//   //       navigate('/security-setup', { replace: true });
//   //     } else {
//   //       navigate('/dashboard', { replace: true });
//   //       toast.success('Welcome back!');
//   //     }
//   //   }
//   // }, [isAuthenticated, isFirstLogin, navigate]);

//   useEffect(() => {
//     if (isAuthenticated) {
//       toast.success('Welcome!');
//       navigate('/dashboard', { replace: true });
//     }
//   }, [isAuthenticated, navigate]);


//   /* --------------------------------------------------------------- */
//   /* 2. Validation                                                    */
//   /* --------------------------------------------------------------- */
//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.emailOrCode.trim()) newErrors.emailOrCode = 'Email or Employee Code is required';
//     if (!formData.password) newErrors.password = 'Password is required';
//     else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   /* --------------------------------------------------------------- */
//   /* 3. Submit → call API                                             */
//   /* --------------------------------------------------------------- */
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     dispatch(loginStart());

//     try {
//       const apiResponse = await authApi.login(formData.emailOrCode, formData.password);

//       const user = {
//         id: apiResponse.employee.id,
//         firstName: apiResponse.employee.first_name?.trim() || 'User',
//         lastName: apiResponse.employee.last_name?.trim() || '',
//         email: apiResponse.employee.email,
//         code: apiResponse.employee.code,
//         role: apiResponse.employee.role?.name || 'Employee',
//         profileImage: apiResponse.employee.profile_img || null,
//         isSuperuser: apiResponse.employee.is_superuser,
//         isStaff: apiResponse.employee.is_staff,
//       };

//       dispatch(
//         loginSuccess({
//           user,
//           token: apiResponse.access,
//           refreshToken: apiResponse.refresh,
//           isFirstLogin: apiResponse.is_first_login,   // ← FROM API
//           employee: apiResponse.employee,
//         })
//       );

//       // No manual navigation here – useEffect will handle it
//     } catch (err) {
//       const message =
//         err.response?.data?.detail ||
//         err.response?.data?.non_field_errors?.[0] ||
//         err.response?.data?.identifier?.[0] ||
//         err.response?.data?.password?.[0] ||
//         err.message ||
//         'Invalid credentials.';

//       dispatch(loginFailure(message));
//       toast.error(message);
//       setErrors({ general: message });
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
//   };

//   /* --------------------------------------------------------------- */
//   /* 4. UI                                                            */
//   /* --------------------------------------------------------------- */
//   return (
//     <div className="min-h-screen w-full grid lg:grid-cols-2 bg-background">

//       {/* LEFT SECTION - Desktop Only */}
//       <div className="hidden lg:flex flex-col justify-center items-center p-12 border-r border-border bg-[#2a3646] relative ">

//         <div className="flex flex-col items-center space-y-10 animate-fade-in">

//           <img
//             src={Logo}
//             alt="MVT CRM Logo"
//             className="w-full h-full object-contain drop-shadow-xl"
//           />

//           <p className="text-white text-center text-lg leading-relaxed">
//             We believe in bestowing our customers with the best of travelling experiences around the world
//           </p>

//         </div>

//         {/* FOOTER on left side */}
//         <p className="text-center text-xs text-white absolute bottom-5">
//           © {new Date().getFullYear()} MVT CRM. Powered by{" "}
//           <a
//             href="https://www.ammrs.in/"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="underline hover:text-white"
//           >
//             AMMRS
//           </a>.
//         </p>
//       </div>

//       {/* RIGHT SECTION - Login */}
//       <div className="flex items-center justify-center p-6 lg:p-20 bg-[#e0e0e0]">

//         <div className="w-full max-w-md">

//           {/* MOBILE LOGO (hidden on desktop) */}
//           <div className="lg:hidden flex flex-col items-center mb-10 animate-fade-in">
//             <img
//               src={Logo}
//               alt="MVT CRM Logo"
//               className="w-full h-full object-contain drop-shadow-md"
//             />
//           </div>

//           {/* LOGIN CARD */}
//           <Card className="w-full shadow-2xl rounded-3xl border-0 animate-slide-in">
//             <CardHeader className="pb-3 text-center">
//               <CardTitle className="text-3xl font-semibold tracking-tight">
//                 Sign In
//               </CardTitle>
//               <CardDescription className="text-sm">
//                 Enter your credentials to continue
//               </CardDescription>
//             </CardHeader>

//             <CardContent>
//               <form onSubmit={handleSubmit} className="space-y-6">

//                 {/* Email / Code */}
//                 <div className="space-y-2">
//                   <Label>Email or Employee Code</Label>
//                   <div className="relative">
//                     <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
//                     <Input
//                       name="emailOrCode"
//                       type="text"
//                       value={formData.emailOrCode}
//                       onChange={handleChange}
//                       placeholder="admin@company.com or EMP001"
//                       className={cn("pl-10", errors.emailOrCode && "form-error")}
//                     />
//                   </div>
//                   {errors.emailOrCode && (
//                     <p className="text-sm text-destructive">{errors.emailOrCode}</p>
//                   )}
//                 </div>

//                 {/* Password */}
//                 <div className="space-y-2">
//                   <Label>Password</Label>
//                   <div className="relative">
//                     <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
//                     <Input
//                       name="password"
//                       type={showPassword ? "text" : "password"}
//                       value={formData.password}
//                       onChange={handleChange}
//                       placeholder="Enter your password"
//                       className={cn("pl-10 pr-10", errors.password && "form-error")}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowPassword((p) => !p)}
//                       className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
//                     >
//                       {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
//                     </button>
//                   </div>
//                   {errors.password && (
//                     <p className="text-sm text-destructive">{errors.password}</p>
//                   )}
//                 </div>

//                 {/* General Error */}
//                 {errors.general && (
//                   <div className="p-3 rounded-lg bg-destructive/10 border border-destructive/20">
//                     <p className="text-sm text-destructive">{errors.general}</p>
//                   </div>
//                 )}

//                 {/* Forgot Password */}
//                 <div className="flex justify-end -mt-2">
//                   <Button
//                     variant="link"
//                     type="button"
//                     onClick={() => navigate("/forgot-password")}
//                     className="text-primary text-sm p-0 h-auto"
//                   >
//                     Forgot Password?
//                   </Button>
//                 </div>

//                 {/* Submit Button */}
//                 <Button
//                   type="submit"
//                   className="w-full h-12 text-base bg-[#2a3646]"
//                   disabled={isLoading}
//                 >
//                   {isLoading ? (
//                     <>
//                       <Loader2 className="mr-2 h-4 w-4 animate-spin" />
//                       Signing in...
//                     </>
//                   ) : (
//                     "Sign In"
//                   )}
//                 </Button>
//               </form>
//             </CardContent>
//           </Card>

//           {/* MOBILE FOOTER */}
//           <p className="text-center text-sm text-black mt-6 lg:hidden">
//             © {new Date().getFullYear()} MVT CRM. Powered by{" "}
//             <a
//               href="https://www.ammrs.in/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="underline hover:text-black"
//             >
//               AMMRS
//             </a>.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  loginStart,
  loginSuccess,
  loginFailure,
  setFirstLogin,
} from '../../store/slices/authSlice';
import authApi from 'api/authApi';
import { Shield, Mail, Lock, Eye, EyeOff, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Checkbox } from 'components/ui/checkbox'; // ← ADD THIS
import { toast } from 'sonner';
import { cn } from '../../lib/utils';
import Logo from 'assets/logo.png';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    emailOrCode: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  // NEW: Remember Me State
  const [rememberMe, setRememberMe] = useState(false);

  /* --------------------------------------------------------------- */
  /* 1. Auto-fill saved email/code on mount                          */
  /* --------------------------------------------------------------- */
  useEffect(() => {
    const savedIdentifier = localStorage.getItem('savedIdentifier') || sessionStorage.getItem('savedIdentifier');
    const savedPassword = localStorage.getItem('savePassword') || '';
    const savedRememberMe = localStorage.getItem('rememberMe') === 'true';

    if (savedIdentifier || savedPassword) {
      setFormData(prev => ({ ...prev, emailOrCode: savedIdentifier, password: savedPassword }));
      setRememberMe(savedRememberMe);
    }
  }, []);

  /* --------------------------------------------------------------- */
  /* 2. Redirect if already logged in                                 */
  /* --------------------------------------------------------------- */
  useEffect(() => {
    if (isAuthenticated) {
      toast.success('Welcome!');
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  /* --------------------------------------------------------------- */
  /* 3. Validation                                                    */
  /* --------------------------------------------------------------- */
  const validateForm = () => {
    const newErrors = {};
    if (!formData.emailOrCode.trim()) newErrors.emailOrCode = 'Email or Employee Code is required';
    if (!formData.password) newErrors.password = 'Password is required';
    else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* --------------------------------------------------------------- */
  /* 4. Submit → Save identifier based on "Remember Me"               */
  /* --------------------------------------------------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    dispatch(loginStart());

    try {
      const apiResponse = await authApi.login(formData.emailOrCode, formData.password);

      const user = {
        id: apiResponse.employee.id,
        firstName: apiResponse.employee.first_name?.trim() || 'User',
        lastName: apiResponse.employee.last_name?.trim() || '',
        email: apiResponse.employee.email,
        code: apiResponse.employee.code,
        role: apiResponse.employee.role?.name || 'Employee',
        profileImage: apiResponse.employee.profile_img || null,
        isSuperuser: apiResponse.employee.is_superuser,
        isStaff: apiResponse.employee.is_staff,
      };

      dispatch(
        loginSuccess({
          user,
          token: apiResponse.access,
          refreshToken: apiResponse.refresh,
          isFirstLogin: apiResponse.is_first_login,
          employee: apiResponse.employee,
        })
      );

      // FIXED & ENHANCED: Save identifier based on "Remember Me"
      if (rememberMe) {
        localStorage.setItem('savedIdentifier', formData.emailOrCode);
        localStorage.setItem('savePassword', formData.password);
        localStorage.setItem('rememberMe', 'true');
      } else {
        sessionStorage.setItem('savedIdentifier', formData.emailOrCode);
        localStorage.removeItem('savedIdentifier');
        localStorage.removeItem('savePassword');
        localStorage.removeItem('rememberMe');
      }

    } catch (err) {
      const message =
        err.response?.data.message ||
        err.response?.data?.detail ||
        err.response?.data?.non_field_errors?.[0] ||
        err.response?.data?.identifier?.[0] ||
        err.response?.data?.password?.[0] ||
        err.message ||
        'Invalid credentials.';

      dispatch(loginFailure(message));
      toast.error(message);
      setErrors({ general: message });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  return (
    <div className="min-h-screen w-full grid lg:grid-cols-2 bg-background">

      {/* LEFT SECTION - Desktop Only */}
      <div className="hidden lg:flex flex-col justify-center items-center p-12 border-r border-border bg-[#2a3646] relative ">
        <div className="flex flex-col items-center space-y-10 animate-fade-in">
          <img src={Logo} alt="Shree Sati 360 Logo" className="bg-white w-full h-full object-contain drop-shadow-xl max-w-[500px] rounded-lg p-4" />
          <p className="text-white text-center text-lg leading-relaxed">
            We believe in bestowing our customers with the best of travelling experiences around the world
          </p>
        </div>
        <p className="text-center text-xs text-white absolute bottom-5">
          © {new Date().getFullYear()} Shree Sati 360. Powered by{" "}
          <a href="https://www.ammrs.in/" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">
            AMMRS
          </a>.
        </p>
      </div>

      {/* RIGHT SECTION - Login */}
      <div className="flex items-center justify-center p-6 lg:p-20 bg-[#e0e0e0]">
        <div className="w-full max-w-md">

          {/* MOBILE LOGO */}
          <div className="lg:hidden flex flex-col items-center mb-10 animate-fade-in">
            <img src={Logo} alt="Shree Sati 360 Logo" className="w-full h-full object-contain drop-shadow-md" />
          </div>

          {/* LOGIN CARD */}
          <Card className="w-full shadow-2xl rounded-3xl border-0 animate-slide-in">
            <CardHeader className="pb-3 text-center">
              <CardTitle className="text-3xl font-semibold tracking-tight">Sign In</CardTitle>
              <CardDescription className="text-sm">Enter your credentials to continue</CardDescription>
            </CardHeader>

            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-6">

                {/* Email / Code */}
                <div className="space-y-2">
                  <Label>Email or Employee Code</Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                      name="emailOrCode"
                      type="text"
                      value={formData.emailOrCode}
                      onChange={handleChange}
                      placeholder="admin@company.com or EMP001"
                      className={cn("pl-10", errors.emailOrCode && "form-error")}
                    />
                  </div>
                  {errors.emailOrCode && <p className="text-sm text-destructive">{errors.emailOrCode}</p>}
                </div>

                {/* Password */}
                <div className="space-y-2">
                  <Label>Password</Label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      className={cn("pl-10 pr-10", errors.password && "form-error")}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(p => !p)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                    >
                      {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                    </button>
                  </div>
                  {errors.password && <p className="text-sm text-destructive">{errors.password}</p>}
                </div>

                {/* NEW: Remember Me + Forgot Password Row */}
                <div className="flex items-center justify-between -mt-2">
                  <div className="flex items-center space-x-2">
                    <Checkbox
                      id="remember"
                      checked={rememberMe}
                      onCheckedChange={(checked) => setRememberMe(checked)}
                    />
                    <Label htmlFor="remember" className="text-sm font-normal cursor-pointer">
                      Remember me
                    </Label>
                  </div>
                  <Button
                    variant="link"
                    type="button"
                    onClick={() => navigate("/forgot-password")}
                    className="text-primary text-sm p-0 h-auto"
                  >
                    Forgot Password?
                  </Button>
                </div>

                {/* General Error */}
                {errors.general && (
                  <div className="p-3 rounded-lg bg-destructive/10 border border-destructive/20">
                    <p className="text-sm text-destructive">{errors.general}</p>
                  </div>
                )}

                {/* Submit */}
                <Button
                  type="submit"
                  className="w-full h-12 text-base bg-[#2a3646]"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      Signing in...
                    </>
                  ) : (
                    "Sign In"
                  )}
                </Button>
              </form>
            </CardContent>
          </Card>

          {/* MOBILE FOOTER */}
          <p className="text-center text-sm text-black mt-6 lg:hidden">
            © {new Date().getFullYear()} Shree Sati 360. Powered by{" "}
            <a href="https://www.ammrs.in/" target="_blank" rel="noopener noreferrer" className="underline hover:text-black">
              AMMRS
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;